__turbopack_context__.v({
  "caret": "MemberMultiSelect-module-scss-module__aEVqQq__caret",
  "checkbox": "MemberMultiSelect-module-scss-module__aEVqQq__checkbox",
  "dropdown": "MemberMultiSelect-module-scss-module__aEVqQq__dropdown",
  "emptyList": "MemberMultiSelect-module-scss-module__aEVqQq__emptyList",
  "footer": "MemberMultiSelect-module-scss-module__aEVqQq__footer",
  "footerBtn": "MemberMultiSelect-module-scss-module__aEVqQq__footerBtn",
  "footerButtons": "MemberMultiSelect-module-scss-module__aEVqQq__footerButtons",
  "footerHint": "MemberMultiSelect-module-scss-module__aEVqQq__footerHint",
  "footerLink": "MemberMultiSelect-module-scss-module__aEVqQq__footerLink",
  "inputBox": "MemberMultiSelect-module-scss-module__aEVqQq__inputBox",
  "label": "MemberMultiSelect-module-scss-module__aEVqQq__label",
  "listContainer": "MemberMultiSelect-module-scss-module__aEVqQq__listContainer",
  "optionAvatar": "MemberMultiSelect-module-scss-module__aEVqQq__optionAvatar",
  "optionLabel": "MemberMultiSelect-module-scss-module__aEVqQq__optionLabel",
  "optionRow": "MemberMultiSelect-module-scss-module__aEVqQq__optionRow",
  "placeholder": "MemberMultiSelect-module-scss-module__aEVqQq__placeholder",
  "root": "MemberMultiSelect-module-scss-module__aEVqQq__root",
  "searchIcon": "MemberMultiSelect-module-scss-module__aEVqQq__searchIcon",
  "searchInput": "MemberMultiSelect-module-scss-module__aEVqQq__searchInput",
  "searchRow": "MemberMultiSelect-module-scss-module__aEVqQq__searchRow",
  "tag": "MemberMultiSelect-module-scss-module__aEVqQq__tag",
  "tagAvatar": "MemberMultiSelect-module-scss-module__aEVqQq__tagAvatar",
  "tagLabel": "MemberMultiSelect-module-scss-module__aEVqQq__tagLabel",
  "tagRemove": "MemberMultiSelect-module-scss-module__aEVqQq__tagRemove",
  "tags": "MemberMultiSelect-module-scss-module__aEVqQq__tags",
});
